<template>
  <n-message-provider>
    <message></message>
  </n-message-provider>
  <index></index>
  <!-- <n-config-provider :hljs="codetoolhljs">
    <index></index>
  </n-config-provider> -->
</template>

<script setup>
import message from "@/components/message"
import index from "@/pages/index.vue"
import { getCurrentInstance, onMounted } from "vue"
// 全局对象
const app = getCurrentInstance().appContext.config.globalProperties.app

// import hljs from "highlight.js/lib/core"
// import csharp from "highlight.js/lib/languages/csharp"
// import java from "highlight.js/lib/languages/java"
// import go from "highlight.js/lib/languages/go"
// import json from "highlight.js/lib/languages/json"
// import xml from "highlight.js/lib/languages/xml"

// hljs.registerLanguage("csharp", csharp)
// hljs.registerLanguage("java", java)
// hljs.registerLanguage("go", go)
// hljs.registerLanguage("json", json)
// hljs.registerLanguage("xml", xml)
// const codetoolhljs = hljs

//组件加载
// onMounted(async () => {
//   await app.codetool.userVisit()
// })
</script>

<style>
#app {
  font-family: "微软雅黑";
  font-size: 14px;
  height: 100%;
}
/* 全局覆盖样式 */
.n-input .n-input__prefix {
  align-items: start;
}
</style>
